<template>
  <div>
  <floating-menu :event-id="eventId"></floating-menu>
  <b-row>
    <b-col cols="12">
      <event-table-management-content />
    </b-col>
  </b-row>
</div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import router from '@/router'
import FloatingMenu from './FloatingMenu.vue'
import EventTableManagementContent from './EventTableManagementContent.vue'


export default {
  components: {
    BRow,
    BCol,
    FloatingMenu,
    EventTableManagementContent,
  },
  data() {
    return {
      eventId: router.currentRoute.params.id
    }
  },
  methods: {
    fetchData() {

    },
  },
  created() {
    this.fetchData()
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>